import React, { Component } from 'react';

import { USER_ROLE_ADMIN } from 'common/userRoles';
import {
  DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS,
  DATA_TABLE_VIEW_ID_SUNSETUP_LISTING_ORDERS,
} from 'common/dataTableConstants';

import { SCREEN_ID_ADMIN_LISTING_ORDERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrSunSetupListingOrders from 'client/components/SrSunSetupListingOrders/SrSunSetupListingOrders';

function getDataTableSettingsFromProps({ listingId }) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS,
    rootViewId: DATA_TABLE_VIEW_ID_SUNSETUP_LISTING_ORDERS,
    initialViewSettings: {
      sort: {
        promiseDate: 'asc',
      },
      filter: {
        id: listingId,
      },
      loadAllData: true,
    },
    itemsPropName:'listings',
    count: 1,
  };

  return dataTableSettings;
}

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_LISTING_ORDERS)
@withScrollToTop
class ListingJobOrders extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Listing Orders',
    section: 'Admin',
  });

  render() {
    const { match } = this.props;
    const listingId = parseInt(match.params.listingId, 10);

    return (
      <SrPartnerPageV2
        navbarTitle='Listing Orders'
        backUrl='/sunsetup/orders'
        redirectToLastLocation={false}
      >
        <SrDataTableConnected
          {...getDataTableSettingsFromProps({ listingId })}
        >
          {({ listings }) => {
            if (!listings[0]) {
              return null;
            }

            const {
              sunlock,
              jobOrders,
              ...listing
            } = listings[0];

            return (
              <SrSunSetupListingOrders
                listing={listing}
                sunlock={sunlock}
                jobOrders={jobOrders}
              />
            );
          }}
        </SrDataTableConnected>
      </SrPartnerPageV2>
    );
  }
}

ListingJobOrders.displayName = 'ListingJobOrders';

export default ListingJobOrders;
